/* tslint:disable */
/* eslint-disable */
/**
 * mindd-stim3-home-api-server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateStimSessionRequest } from '../model';
// @ts-ignore
import type { StimSession } from '../model';
// @ts-ignore
import type { StimSessionCount } from '../model';
// @ts-ignore
import type { StimSessionCountRequest } from '../model';
/**
 * StimSessionControllerApi - axios parameter creator
 * @export
 */
export const StimSessionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 처방 id 목록을 받아 처방당 삭제되지 않은 세션 개수를 반환한다. 존재하지 않는 id, 다른 기관 처방, 삭제된 처방은 응답에서 제외한다(부분 성공). 응답 순서는 보장하지 않으므로 prescriptionId 로 매핑한다.
         * @summary 처방별 자극 세션 개수 벌크 조회
         * @param {StimSessionCountRequest} stimSessionCountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countByPrescriptionIds: async (stimSessionCountRequest: StimSessionCountRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stimSessionCountRequest' is not null or undefined
            assertParamExists('countByPrescriptionIds', 'stimSessionCountRequest', stimSessionCountRequest)
            const localVarPath = `/api/v1/sessions/counts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stimSessionCountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary StimSession 생성 (다건)
         * @param {string} prescriptionId 
         * @param {CreateStimSessionRequest} createStimSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (prescriptionId: string, createStimSessionRequest: CreateStimSessionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prescriptionId' is not null or undefined
            assertParamExists('create', 'prescriptionId', prescriptionId)
            // verify required parameter 'createStimSessionRequest' is not null or undefined
            assertParamExists('create', 'createStimSessionRequest', createStimSessionRequest)
            const localVarPath = `/api/v1/prescriptions/{prescriptionId}/sessions`
                .replace(`{${"prescriptionId"}}`, encodeURIComponent(String(prescriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStimSessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary stimSession id 기반 StimSession 삭제
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteById: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('deleteById', 'sessionId', sessionId)
            const localVarPath = `/api/v1/sessions/{sessionId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 처방 기반 StimSession 모음 조회
         * @param {string} prescriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByPrescriptionId: async (prescriptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prescriptionId' is not null or undefined
            assertParamExists('findAllByPrescriptionId', 'prescriptionId', prescriptionId)
            const localVarPath = `/api/v1/prescriptions/{prescriptionId}/sessions`
                .replace(`{${"prescriptionId"}}`, encodeURIComponent(String(prescriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary stimSession id 기반 StimSession 조회
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findById: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('findById', 'sessionId', sessionId)
            const localVarPath = `/api/v1/sessions/{sessionId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StimSessionControllerApi - functional programming interface
 * @export
 */
export const StimSessionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StimSessionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 처방 id 목록을 받아 처방당 삭제되지 않은 세션 개수를 반환한다. 존재하지 않는 id, 다른 기관 처방, 삭제된 처방은 응답에서 제외한다(부분 성공). 응답 순서는 보장하지 않으므로 prescriptionId 로 매핑한다.
         * @summary 처방별 자극 세션 개수 벌크 조회
         * @param {StimSessionCountRequest} stimSessionCountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countByPrescriptionIds(stimSessionCountRequest: StimSessionCountRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StimSessionCount>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countByPrescriptionIds(stimSessionCountRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StimSessionControllerApi.countByPrescriptionIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary StimSession 생성 (다건)
         * @param {string} prescriptionId 
         * @param {CreateStimSessionRequest} createStimSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(prescriptionId: string, createStimSessionRequest: CreateStimSessionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StimSession>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(prescriptionId, createStimSessionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StimSessionControllerApi.create']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary stimSession id 기반 StimSession 삭제
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteById(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteById(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StimSessionControllerApi.deleteById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 처방 기반 StimSession 모음 조회
         * @param {string} prescriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllByPrescriptionId(prescriptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StimSession>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllByPrescriptionId(prescriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StimSessionControllerApi.findAllByPrescriptionId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary stimSession id 기반 StimSession 조회
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findById(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StimSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findById(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StimSessionControllerApi.findById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StimSessionControllerApi - factory interface
 * @export
 */
export const StimSessionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StimSessionControllerApiFp(configuration)
    return {
        /**
         * 처방 id 목록을 받아 처방당 삭제되지 않은 세션 개수를 반환한다. 존재하지 않는 id, 다른 기관 처방, 삭제된 처방은 응답에서 제외한다(부분 성공). 응답 순서는 보장하지 않으므로 prescriptionId 로 매핑한다.
         * @summary 처방별 자극 세션 개수 벌크 조회
         * @param {StimSessionCountRequest} stimSessionCountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countByPrescriptionIds(stimSessionCountRequest: StimSessionCountRequest, options?: any): AxiosPromise<Array<StimSessionCount>> {
            return localVarFp.countByPrescriptionIds(stimSessionCountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary StimSession 생성 (다건)
         * @param {string} prescriptionId 
         * @param {CreateStimSessionRequest} createStimSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(prescriptionId: string, createStimSessionRequest: CreateStimSessionRequest, options?: any): AxiosPromise<Array<StimSession>> {
            return localVarFp.create(prescriptionId, createStimSessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary stimSession id 기반 StimSession 삭제
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteById(sessionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteById(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 처방 기반 StimSession 모음 조회
         * @param {string} prescriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByPrescriptionId(prescriptionId: string, options?: any): AxiosPromise<Array<StimSession>> {
            return localVarFp.findAllByPrescriptionId(prescriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary stimSession id 기반 StimSession 조회
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findById(sessionId: string, options?: any): AxiosPromise<StimSession> {
            return localVarFp.findById(sessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StimSessionControllerApi - object-oriented interface
 * @export
 * @class StimSessionControllerApi
 * @extends {BaseAPI}
 */
export class StimSessionControllerApi extends BaseAPI {
    /**
     * 처방 id 목록을 받아 처방당 삭제되지 않은 세션 개수를 반환한다. 존재하지 않는 id, 다른 기관 처방, 삭제된 처방은 응답에서 제외한다(부분 성공). 응답 순서는 보장하지 않으므로 prescriptionId 로 매핑한다.
     * @summary 처방별 자극 세션 개수 벌크 조회
     * @param {StimSessionCountRequest} stimSessionCountRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StimSessionControllerApi
     */
    public countByPrescriptionIds(stimSessionCountRequest: StimSessionCountRequest, options?: RawAxiosRequestConfig) {
        return StimSessionControllerApiFp(this.configuration).countByPrescriptionIds(stimSessionCountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary StimSession 생성 (다건)
     * @param {string} prescriptionId 
     * @param {CreateStimSessionRequest} createStimSessionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StimSessionControllerApi
     */
    public create(prescriptionId: string, createStimSessionRequest: CreateStimSessionRequest, options?: RawAxiosRequestConfig) {
        return StimSessionControllerApiFp(this.configuration).create(prescriptionId, createStimSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary stimSession id 기반 StimSession 삭제
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StimSessionControllerApi
     */
    public deleteById(sessionId: string, options?: RawAxiosRequestConfig) {
        return StimSessionControllerApiFp(this.configuration).deleteById(sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 처방 기반 StimSession 모음 조회
     * @param {string} prescriptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StimSessionControllerApi
     */
    public findAllByPrescriptionId(prescriptionId: string, options?: RawAxiosRequestConfig) {
        return StimSessionControllerApiFp(this.configuration).findAllByPrescriptionId(prescriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary stimSession id 기반 StimSession 조회
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StimSessionControllerApi
     */
    public findById(sessionId: string, options?: RawAxiosRequestConfig) {
        return StimSessionControllerApiFp(this.configuration).findById(sessionId, options).then((request) => request(this.axios, this.basePath));
    }
}

